<template>
    <div data-testid="step-returnToDesktop" class="container">
        <h1 class="container__standard-header">
            {{ $t(`${TRANSLATION_KEY}.personalDataHeader`) }}
        </h1>
        <p class="t-bold t-center container__subheader">
            {{ responseData.uploadActionError }}
            <br />
            <span>
                {{ $t(`${TRANSLATION_KEY}.continuingRegistrationProcess`) }}
            </span>
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { SET_PROGRESS } from '@/constants/mutation-types';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';

export default defineComponent({
    name: 'ReturnToDesktop',
    setup() {
        const store = useStore();
        const { t } = useI18n();
        const TRANSLATION_KEY = 'steps.ReturnToDesktop';

        const requestCount = ref(0);
        const maxRequests = 3;

        function switchToNextStep() {
            if (requestCount.value >= maxRequests) {
                return;
            }
            requestCount.value++;
            const ajaxService = store.state.ajaxService;
            ajaxService.post(
                ajaxService.PROXY_ROUTE + 'document/mobile-return-to-desktop',
                {
                    token: ajaxService.getToken(),
                }
            );

            if (requestCount.value < maxRequests) {
                setTimeout(() => {
                    switchToNextStep();
                }, 3000);
            }
        }

        const responseData = computed(() => store.state.formData);

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.RETURN_TO_DESKTOP);
            switchToNextStep();
        });

        return {
            t,
            responseData,
            TRANSLATION_KEY,
        };
    },
});
</script>
